module.exports = __webpack_public_path__ + "static/media/bg-login.554bf84f.png";